// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.upload-documentos button i {
  font-size: 1rem;
}
.upload-documentos > div.titulo {
  background: var(--primary);
  color: var(--white);
  padding: 1rem;
  border-radius: 0.2rem 0.2rem 0 0;
}
.upload-documentos > div.contenido.conPadding {
  padding: 1rem;
}
.upload-documentos .d-flex {
  gap: 1rem;
}
.upload-documentos .mobile {
  display: none;
}
.upload-documentos .desktop.hidden {
  display: none;
}

@media (max-width: 767.98px) {
  .mobile,
  .mobile.hidden {
    display: initial !important;
  }
  .desktop {
    display: none !important;
  }
  .desktop.desktop.isImage, .desktop .desktop.hidden.isImage {
    display: initial !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/documentos/upload/upload.component.scss"],"names":[],"mappings":"AACC;EACC,eAAA;AAAF;AAEC;EACC,0BAAA;EACA,mBAAA;EACA,aAAA;EACA,gCAAA;AAAF;AAEC;EACC,aAAA;AAAF;AAEC;EACC,SAAA;AAAF;AAEC;EACC,aAAA;AAAF;AAEC;EACC,aAAA;AAAF;;AAIA;EACC;;IAEC,2BAAA;EADA;EAGD;IACC,wBAAA;EADA;EAEA;IACC,2BAAA;EAAD;AACF","sourcesContent":[".upload-documentos {\n\t& button i {\n\t\tfont-size: 1rem;\n\t}\n\t& > div.titulo {\n\t\tbackground: var(--primary);\n\t\tcolor: var(--white);\n\t\tpadding: 1rem;\n\t\tborder-radius: 0.2rem 0.2rem 0 0;\n\t}\n\t& > div.contenido.conPadding {\n\t\tpadding: 1rem;\n\t}\n\t& .d-flex {\n\t\tgap: 1rem;\n\t}\n\t& .mobile {\n\t\tdisplay: none;\n\t}\n\t& .desktop.hidden {\n\t\tdisplay: none;\n\t}\n}\n\n@media (max-width: 767.98px) {\n\t.mobile,\n\t.mobile.hidden {\n\t\tdisplay: initial !important;\n\t}\n\t.desktop {\n\t\tdisplay: none !important;\n\t\t&.desktop.isImage, .desktop.hidden.isImage {\n\t\t\tdisplay: initial !important;\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
